import React from "react";
import { Box, IconButton } from "@mui/material";
// import AttachFileIcon from "@mui/icons-material/AttachFile";
import MicIcon from "@mui/icons-material/Mic";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";

const ChatFooter = ({
  selectedImage,
  userInput,
  listening,
  setUserInput,
  handleRemoveImage,
  handleImageChange,
  handleMicClick,
  handleSendMessage,
  handleKeyDown,
}) => {
  return (
    <Box className="chat-footer">
      {selectedImage && (
        <div className="image-preview-container">
          <img
            src={URL.createObjectURL(selectedImage)}
            alt="Preview"
            className="image-preview"
          />
          <IconButton onClick={handleRemoveImage} className="remove-image-btn">
            <DeleteIcon />
          </IconButton>
        </div>
      )}
      <input
        className="bc-show"
        type="text"
        placeholder="How can I help?"
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <div className="chat-icons">
        {/* <IconButton component="label">
          <AttachFileIcon sx={{ color: "gray" }} />
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleImageChange}
          />
        </IconButton> */}

        {userInput.length === 0 && (
          <IconButton
            onClick={handleMicClick}
            sx={{ color: listening ? "red" : "gray" }}
          >
            <MicIcon />
          </IconButton>
        )}

        {userInput.length > 0 && (
          <IconButton
            sx={{
              color: userInput ? "black" : "gray",
              "&.Mui-disabled": { color: "gray !important" },
            }}
            onClick={() => handleSendMessage()}
            className="send-btn"
            disabled={listening || !userInput}
          >
            <SendIcon />
          </IconButton>
        )}
      </div>
    </Box>
  );
};

export default ChatFooter;
